import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../constants/colors";

const BottomVehicleDetails = ({
  locationDetails,
  vehicleDetails,
  deviceDetails = {},
  vehicleImages,
  onClose,
}:any) => {
  return (
    <>
      <Typography variant="h6" color="textPrimary" sx={{ textAlign: "center" }}>
        Device Details
      </Typography>

      <Box
        sx={{
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: "16px",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "20px",
            }}
          >
            {vehicleImages?.front ? (
              <img
                src={"https://dc.novaeavenue.com" + vehicleImages?.front}
                alt="Vehicle Front img Not Found"
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "8px",
                  objectFit: "cover",
                  color: colors.orange,
                }}
              />
            ) : (
              <img
                src={"/assets/icons/backCar.png"}
                alt="VD"
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "8px",
                  objectFit: "cover",
                  color: colors.orange,
                }}
              />
            )}
            {vehicleImages?.rear ? (
              <img
                src={"https://dc.novaeavenue.com" + vehicleImages?.rear}
                alt="Vehicle Rear img Not Found"
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "8px",
                  objectFit: "cover",
                  color: colors.orange,
                }}
              />
            ) : (
              <img
                src={"/assets/icons/frontCar.jpeg"}
                alt="VD"
                style={{
                  width: "55%",
                  height: "55%",
                  borderRadius: "8px",
                  objectFit: "cover",
                  color: colors.orange,
                }}
              />
            )}
          </Box>
        </Box>

        <Box
          sx={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            paddingLeft: "16px",
          }}
        >
          <Box mb={2}>
            <Typography variant="h6" color="textPrimary">
              {vehicleDetails?.devicename}
            </Typography>
          </Box>
          <Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="body2" color="textPrimary">
                Driver Name
              </Typography>
              <Typography
                textTransform="capitalize"
                variant="body2"
                fontWeight="bold"
                color="textPrimary"
              >
                {vehicleDetails?.driver_name}
              </Typography>
            </Box>
            {Object.keys(deviceDetails)?.map((key) => (
              <Box key={key} display="flex" justifyContent="space-between">
                <Typography
                  variant="body2"
                  color="textPrimary"
                  sx={{ lineHeight: "30px" }}
                >
                  {key}
                </Typography>
                <Typography
                  textTransform="capitalize"
                  variant="body2"
                  fontWeight="bold"
                  color="textPrimary"
                >
                  {deviceDetails[key]}
                </Typography>
              </Box>
            ))}
            <Box display="flex" justifyContent="space-between">
              <Typography variant="body2" color="textPrimary">
                Last Location
              </Typography>
              <Typography
                textTransform="capitalize"
                variant="body2"
                fontWeight="bold"
                color="textPrimary"
              >
                {locationDetails}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default BottomVehicleDetails;
